import React, { useEffect, useState } from "react";
import DeployService from "../http/DeployService";
import { DeployRecord } from "../entities/DeployRecord";
import { List, Button } from "antd";
import './DeployHistoryPage.css';
import { ServiceInfo } from "../entities/ServiceInfo";
import { DEPLOY_ENV } from "../utils/config";
import {DeployState, DeployStateExt} from "../enums/DeployState";
import DateFormatUtils from "../utils/DateFormatUtils";

interface DeployHistoryPageProps {
    service: ServiceInfo;
}

const DeployHistoryPage: React.FC<DeployHistoryPageProps> = ({ service }) => {
    const [deployRecords, setDeployRecords] = useState<DeployRecord[]>([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        DeployService.listDeployRecords({ appKey: service.appKey, env: DEPLOY_ENV, page: { pageNum, pageSize }}).then((response) => {
            if (response.isFailed()) {
                return;
            }
            setDeployRecords(response.data.list || []);
            setTotalRecords(response.data.page.totalCount || 0);
        });
    }, [service.appKey, pageNum, pageSize]);

    const handleItemClick = (id: number) => {
        window.open(`/detail/deploy?id=${id}`, '_blank');
    };

    const handlePageChange = (page: number, size?: number) => {
        setPageNum(page);
        if (size) {
            setPageSize(size);
        }
    };

    return (
        <div className="deploy-history-page">
            <List
                itemLayout="horizontal"
                dataSource={deployRecords}
                renderItem={record => (
                    <List.Item
                        actions={[<Button type="link" onClick={() => handleItemClick(record.id)}>查看详情</Button>]}
                    >
                        <List.Item.Meta
                            title={
                                `创建时间: ${DateFormatUtils.format(record.createTime)}`
                            }
                            description={
                                <div>
                                    <div className="text-block">
                                        更新时间：{DateFormatUtils.format(record.updateTime)}
                                    </div>
                                    <div className="text-block">
                                        状态：
                                        {
                                            record.rollbackState === DeployState[DeployState.PENDING] ?
                                                <span style={{color: DeployStateExt.getStatusColorFromString(record.deployState)}}>
                                                    {DeployStateExt.getDeployStateTextFromString(record.deployState)}
                                                </span> :
                                                <span style={{color: DeployStateExt.getStatusColor(DeployState.FAILED)}}>
                                                    {DeployStateExt.getRollbackStateTextFromString(record.rollbackState)}
                                                </span>
                                        }
                                    </div>
                                </div>
                            }
                        />
                    </List.Item>
                )}
                pagination={{
                    current: pageNum,
                    pageSize: pageSize,
                    total: totalRecords,
                    onChange: handlePageChange,
                    showSizeChanger: true,
                    pageSizeOptions: ['20']
                }}
            />
        </div>
    );
};

export default DeployHistoryPage;